import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { PopoverRef } from '../../../components/popover/popover-ref';
import { RecentRealEstate } from '../../../services/recent-real-estate-cache.service';
import { DateUtil } from '../../../../app/util/DateUtil';
import dayjs from 'dayjs';

export interface RecentPanelData {
	recentRealEstates: RecentRealEstate[];
	activeId: string | null;
	onSelect: (re: RecentRealEstate) => void;
	onClear: () => void;
	onPanelEnter: () => void;
	onPanelLeave: () => void;
}

@Component({
	selector: 'ara-recent-panel',
	imports: [MatIconModule, TranslocoModule],
	templateUrl: './recent-panel.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./recent-panel.component.scss'],
})
export class RecentPanelComponent {
	private readonly popoverRef = inject<PopoverRef<RecentPanelData>>(PopoverRef);
	private readonly dateUtil = inject(DateUtil);

	readonly recentRealEstates: RecentRealEstate[] = this.popoverRef.data.recentRealEstates;
	readonly activeId: string | null = this.popoverRef.data.activeId;
	private readonly onSelect = this.popoverRef.data.onSelect;
	readonly onClear = this.popoverRef.data.onClear;
	readonly onPanelEnter = this.popoverRef.data.onPanelEnter;
	readonly onPanelLeave = this.popoverRef.data.onPanelLeave;

	selectRealEstate(re: RecentRealEstate): void {
		this.onSelect(re);
	}

	formatDate(iso?: string): string {
		if (!iso) return '—';
		return this.dateUtil.setDateFormatByActiveLang(iso, '');
	}

	formatTime(iso?: string): string {
		if (!iso) return '';
		return dayjs(iso).format('HH:mm:ss');
	}
}
